<template>
  <home-layout>
    <div class="row main-topic">
      <div class="col-md-12">
        <h3 class="text-topic">ติดตามสินค้า</h3>
      </div>
    </div>
    <div v-if="!orders || orders.length <= 0">
      <h5 class="text-center">ไม่มีข้อมูล</h5>
    </div>
    <span v-if="orders" >
      <div class="box-data" v-for="(order , index) in orders" :key="index">
        <p class="toppic">รหัสคำสั่งซื้อ : {{order.get('purchaseOrderNo')}} 
          <span class="status">กำลังดำเนินการ</span>
        </p>
        <div class="detail">
          <purchase-step-bar :order="order"/>
          <p class="text-right" style="font-size:14px;">เลขที่ใบสั่งซื้อ : {{order.get('purchaseOrderNo')}}</p>
          <p class="text-right" style="font-size:14px;">วันที่สังซื้อ : {{order.get('purchaseDate') | moment('DD/MM/YYYY')}}</p>
          <div class="row">
            <div class="col-md-6">
              <p class="head"><b>ที่อยู่ในการจัดส่งสินค้า</b></p>
              <div style="font-size:14px;padding-left:15px;">
                <p><b>ชื่อ - สกุล : </b>{{order.get('orderName')}}</p>
                <p><b>เบอร์ติดต่อ : </b>{{order.get('orderTel')}}</p>
                <p><b>เบอร์ติดต่อ (สำรอง) : </b>{{order.get('tel2')}}</p>
                <p><b>ที่ออยู่ : </b>{{order.get('orderAddress')}}</p>
              </div>
            </div>
            <div class="col-md-6">
              <p class="head"><b>ที่อยู่ใบกำกับภาษี</b></p>
              <div style="font-size:14px;padding-left:15px;">
                <p><b>ชื่อ - สกุล : </b>{{order.get('orderNameTax')}}</p>
                <p><b>เลขประจำตัวผู้เสียภาษี : </b>{{order.get('taxId')}}</p>
                <p><b>ที่ออยู่ : </b>{{order.get('orderAddressTax')}}</p>
              </div>
            </div>
            <div class="col-md-12" >
              <div style="overflow-x: scroll; overflow-y: hidden;">
                <table width="890px">
                  <tr>
                    <th class="text-center" width="50px">ลำดับ</th>
                    <th class="text-center" width="440px">รายการ</th>
                    <th class="text-center" width="110px">ราคาต่อชิ้น(บาท)</th>
                    <th class="text-center" width="80px">จำนวน(ชิ้น)</th>
                    <th class="text-center text-danger" width="100px">ส่วนลด(บาท)</th>
                    <th class="text-center" width="110px">รวมเป็นเงิน(บาท)</th>
                  </tr>
                  <tr v-for="(item , index) in order.get('sets')" :key="index">
                    <td class="text-center">{{index + 1}}</td>
                    <td style="padding-left:10px">
                      <!-- <img :src="hashProduct[item.productId].get('images')[0]._url" width="50px"> -->
                      {{item.productName}}
                      </td>
                    <td class="text-right">{{item.pricePer | currency}}</td>
                    <td class="text-center">{{item.number ? item.number : item.setNumber}}</td>
                    <td class="text-right text-danger font-weight-bold">{{(item.setDiscountBath + item.discountBath) * -1 | currency}}</td>
                    <td class="text-right">{{item.cost | currency}}</td>
                  </tr>
                </table>
              </div>
              <div style="width:100%; display: inline-block;">
                <div class="sum">
                  <div class="row">
                    <div class="col-8"><b>ราคา</b></div>
                    <div class="col-4 text-right">{{order.get('cost') + order.get('totalDiscount') * -1  | currency}}</div>
                  </div>
                  <div class="row ">
                    <div class="col-8"><b class="text-danger">ส่วนลด (บาท)</b></div>
                    <div class="col-4 text-right text-danger font-weight-bold">{{order.get('totalDiscount') * -1 | currency}}</div>
                  </div>
                  <div class="row">
                    <div class="col-8"><b>ยอดรวมก่อนภาษี (บาท)</b></div>
                    <div class="col-4 text-right">{{order.get('beforeVat') | currency}}</div>
                  </div>
                  <div class="row">
                    <div class="col-8"><b>ภาษี {{order.get('vatPer')}}% (บาท)</b></div>
                    <div class="col-4 text-right">{{order.get('vatBath') | currency}}</div>
                  </div>
                  <div class="row">
                    <div class="col-8"><b>ค่าจัดส่ง (บาท)</b></div>
                    <div class="col-4 text-right">{{order.get('deliveryBath') | currency}}</div>
                  </div>
                  <div class="row">
                    <div class="col-8"><b>รวมเป็นเงินทั้งสิ้น (บาท)</b></div>
                    <div class="col-4 text-right">{{order.get('cost') | currency}}</div>
                  </div>
                </div>
              </div>
              <div class="note">
                <div><b>หมายเหตุ : {{order.get('note')}}</b></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </span>
    <!-- Modal Confirm -->
    <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">ยืนยันได้รับสินค้าแล้ว</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            ฉันได้รับสินค้าแล้ว และได้ตรวจสอบสินค้าแล้วว่าถูกตามรายการสั้งซื้อ
          </div>
          <div class="modal-footer">
            <button type="button" class="btn-main" width="70px" style="margin:0 10px;width:80px;border-radius: 2px;" @click="acceptOrder()">ยืนยัน</button>
            <button type="button" class="btn-quotation" width="70px" style="margin:0;width:80px;border-radius: 2px;" data-dismiss="modal">ยกเลิก</button>
          </div>
        </div>
      </div>
    </div>
    <!-- End Modal Confirm -->
  </home-layout>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      orders:[],
      // hashProduct: {}
    }
  },
  async created() {
    // ------------------------mixpanel---------------------------
    if(this.user) this.$mixpanel.track(`view-tracking-order`, {id : this.user.id , tel : this.user.get('tel') , name : this.user.get('userProfile').get('firstName')})
    else this.$mixpanel.track(`view-tracking-order`)
    // -----------------------------------------------------------

    this.orders = await this.Parse.Cloud.run("MarketProduct_getOrderTrackingByUser").catch(ex => { console.log(ex) })
    // for(let product of this.allProduct){
    //   this.hashProduct[product.id] = product
    // }
  },
  methods: {
    acceptOrder(){
      console.log(this.order)
      // this.order.set('isAccept' , true)
      // this.order.set('acceptDate' , new Date())
      // this.order.save().catch(e => console.log(e))
      // this.calStep()
    }
  },
  computed: {
    ...mapState([
      'allProduct'
    ])
  },
}
</script>
<style scoped>
*{
  color: rgb(80, 80, 80);
}
.box-data{
  border: 1px solid rgba(148, 148, 148, 0.5);
  border-radius: 3px;
  margin-bottom: 15px;
}
.box-data .toppic{
  margin: 0;
  padding: 15px 20px;
  font-weight: bold;
  background-color: rgba(248, 251, 62, 0.346);
}
.box-data .toppic .status{
  float: right;
  padding: 5px 15px;
  color: white;
  margin: 0;
  margin-top: -5px;
  border-radius: 3px;
  background-color: rgba(195, 178, 21, 0.673);
}
.box-data .detail{
  padding: 10px 10px;
}
.box-data .detail p{
  margin-bottom: 8px;
}
.box-data .detail .head{
  background: #f1f1f1;
  padding: 5px;
}
table{
  margin-top: 15px;
  font-size: 14px;
  overflow-x: scroll;
  
}
table, td, th {
  border: 1px solid rgba(148, 148, 148, 0.5);
}
td, th {
  padding: 5px;
}
.sum{
  /* border: 1px solid; */
  width: 250px;
  float: right;
  font-size: 14px;
  margin: 10px 0;
  display: block;
}
.sum div{
  margin-bottom: 3px;
}
.note{
  font-size: 14px;
  padding: 0 20px 20px 20px;
}
</style>
